import {
    Component,
    ElementRef,
    EventEmitter,
    Inject,
    OnInit,
    Optional,
    Output,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@cmps/ng-bootstrap';
import { IOption } from '@cmps/ng-select';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'indefinite-observable';
import { Observable } from 'rxjs';

import { WidgetConfiguration } from '../../widget/config.widget.model';
import { CMPS_WIDGET_CONFIG } from '../../widget/widget.metadata';
import { TranslationKeyMap } from '../coaching-insight.i18n';
import { OldOaWidgetTypeId } from '../coaching-insight.module';

import { ColumnConfigItem, Icon } from './models/coaching.global.model';
import { Metric, OAFilter } from './models/oa.model';
import {
    clearSessionStorage,
    getFilterOptions,
} from './opportunityalignment/coachingInsight-session-storage-functions';
import { CoachingInsightWidgetService } from './services/coaching-insight.widget.service';
import { TeamOAService } from './services/team-oa.service';

// maintain a list of Team Member Metrics
@Component({
    selector: 'cmps-coaching-filter',
    templateUrl: './coaching-filter.component.html',
    // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoachingFilter implements OnInit {
    @Output() filterToggled: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    @Output() filterApplied: EventEmitter<OAFilter> =
        new EventEmitter<OAFilter>();

    @Output() toggledDisplay: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    @ViewChild('oaFilterWindow') oaFilterWindow: ElementRef;
    @ViewChild('filterwindowtpl', { static: true })
    filterwindowtpl: TemplateRef<any>;

    private _modal: NgbModalRef;
    i18n = TranslationKeyMap;

    oametricsoptions: Observable<IOption[]>;

    filterOptions: OAFilter = {
        filterMetrics: [],
        opportunityType: null,
        coachingState: null,
        filterSort: '',
    };

    oafilterMetrics: string[] = [];
    oafilterMetricsSelected: string;
    oafilterCoachingState: string[] = [];
    oafilterCoachingstateSelected: string;

    noFilterOptionsSelected: boolean = false;
    hasFiltersApplied: boolean = false;

    destroyedComponent = false;

    oafilterSortOptions = [
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        {
            value: '',
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            label: `${this._translateService.instant(
                TranslationKeyMap._7428_PLEASE_SELECT_SORT,
            )}...`,
        },
        {
            value: 'GoalPercentDesc',
            label: this._translateService.instant(
                TranslationKeyMap._7429__CLOSEST_TO_FURTHEST____TO_GOAL,
            ),
        },
        {
            value: 'GoalPercentAsc',
            label: this._translateService.instant(
                TranslationKeyMap._7430__FURTHEST_TO_CLOSEST____TO_GOAL,
            ),
        },
        {
            value: 'TargetPercentDesc',
            label: this._translateService.instant(
                TranslationKeyMap._7431__CLOSEST_TO_FURTHEST____TO_TARGET,
            ),
        },
        {
            value: 'TargetPercentAsc',
            label: this._translateService.instant(
                TranslationKeyMap._7432__FURTHEST_TO_CLOSEST____TO_TARGET,
            ),
        },
        {
            value: 'NumOppsDesc',
            label: this._translateService.instant(
                TranslationKeyMap._7433__MOST_TO_LEAST____OF_OPPORTUNITIES,
            ),
        },
        {
            value: 'NumOppsAsc',
            label: this._translateService.instant(
                TranslationKeyMap._7434__LEAST_TO_MOST____OF_OPPORTUNITIES,
            ),
        },
    ];

    oametrictypeoptions: Array<{ value: string; label: string }> = [
        {
            value: 'OA',
            label: this._translateService.instant(
                TranslationKeyMap._7435_OPPORTUNITY,
            ),
        },
        {
            value: 'NONOA',
            label: this._translateService.instant(
                TranslationKeyMap._7436_NON_OPPORTUNITY,
            ),
        },
        {
            value: 'BOTH',
            label: this._translateService.instant(TranslationKeyMap._7437_BOTH),
        },
    ];

    oametrictypeSelected: string = '';
    oafilterSortSelected: string;
    oafilteropened: boolean = false;
    appliedFilters: any[];
    addingMetric: boolean;

    tempMetricValue: any = null;

    showActivePerformers = false;
    toggleActiveSub: Subscription;

    ColumnsConfig: ColumnConfigItem[] = [];
    ColumnsConfigSub: Subscription;

    constructor(
        private readonly _teamOAService: TeamOAService,
        private readonly _modalService: NgbModal,
        private readonly _coachingInsightService: CoachingInsightWidgetService,
        // private readonly _cdRef: ChangeDetectorRef,
        public readonly activeModal: NgbActiveModal,
        private readonly _translateService: TranslateService,
        @Optional()
        @Inject(CMPS_WIDGET_CONFIG)
        private readonly _config: WidgetConfiguration,
    ) {}

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnInit() {
        if (this.destroyedComponent) {
            // this._cdRef.reattach();
        }
        this.oametricsoptions = this._teamOAService.allmetrics;
        // eslint-disable-next-line no-return-assign
        this.toggleActiveSub =
            this._teamOAService.showActivePerformers.subscribe(
                (g) => (this.showActivePerformers = g),
            );
        this.ColumnsConfigSub = this._teamOAService.columns.subscribe((e) => {
            if (e) {
                this.ColumnsConfig = e.filter(
                    (p) =>
                        p.templateName !== null && p.templateName !== 'oascore',
                );
                if (this._config && this._config.typeId !== OldOaWidgetTypeId) {
                    const filterOptionLocal = getFilterOptions();
                    if (filterOptionLocal) {
                        if (filterOptionLocal.filterMetrics.length > 0) {
                            this.filterOptions.filterMetrics =
                                filterOptionLocal.filterMetrics;
                            this.hasFiltersApplied = true;
                            this.appliedFilters =
                                filterOptionLocal.filterMetrics;
                        }
                        if (
                            filterOptionLocal.filterSort !== '' &&
                            this.filterOptions.filterSort !==
                                filterOptionLocal.filterSort
                        ) {
                            this.filterOptions.filterSort =
                                filterOptionLocal.filterSort;
                            this.applyFilters(false, false);
                        }
                        this._teamOAService.applyGlobalFilters(
                            filterOptionLocal,
                        );
                    } else {
                        this.oafilterMetrics = [];
                        this.filterOptions.filterMetrics = [];
                        this.filterOptions.filterSort = '';
                        this.appliedFilters = [];
                        this.applyFilters(true, false);
                    }
                }
            }
        });
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    openModal() {
        this._modal = this._modalService.open(this.filterwindowtpl, {
            // windowClass: 'legend-body',
            container: '.oa-filter-modal',
            size: 'lg',
            centered: true,
        });
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    closeModal() {
        if (this._modal) this._modal.close();
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    toggleOAFilter(el) {
        this.oafilteropened = !this.oafilteropened;
        this.openModal();
        // this.filterToggled.emit(this.oafilteropened);

        // setTimeout(() => {
        //     $(this.oaFilterWindow.nativeElement).offset({
        //         top: $(el).offset().top - ($(this.oaFilterWindow.nativeElement).outerHeight() / 2) + 20,
        //         left: $(el).offset().left - ($(this.oaFilterWindow.nativeElement).outerWidth(true) + 10)
        //     });
        //     $(this.oaFilterWindow.nativeElement).css("opacity", 1);
        //     this._cdRef.detectChanges();
        // }, 300)
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    applyFilters(overridecheck: boolean, triggerCd: boolean) {
        this.noFilterOptionsSelected = false;

        // auto-add whatever was selected in dropdown in case user forgets to click (+)
        if (this.oafilterMetricsSelected) {
            this.addMetricToFilters();
        }

        if (
            !overridecheck &&
            !this.filterOptions.filterMetrics.length &&
            !this.filterOptions.filterSort
        ) {
            this.noFilterOptionsSelected = true;
            return;
        }
        this._teamOAService.applyGlobalFilters(this.filterOptions);

        this.appliedFilters = this.filterOptions.filterMetrics;

        this.filterApplied.emit(this.filterOptions);

        if (this.filterOptions.filterMetrics.length) {
            this.hasFiltersApplied = true;
        } else {
            this.hasFiltersApplied = false;
        }
        if (overridecheck !== false) {
            this.closeOAFilter();
        }

        // eslint-disable-next-line @typescript-eslint/dot-notation
        // if (
        //     (triggerCd == null || triggerCd === false) &&
        //     // eslint-disable-next-line @typescript-eslint/dot-notation
        //     !this._cdRef['destroyed']
        // ) {
        //     this._cdRef.detectChanges();
        // }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    clearFilters() {
        this.oafilterMetrics = [];
        this.filterOptions.filterMetrics = [];
        this.appliedFilters = [];
        this.filterOptions.filterSort = '';
        this.applyFilters(true, false);

        this._teamOAService.resetColumnIcons();
        this._teamOAService.toggleAllMetricFromGlobalFilter(false);
        clearSessionStorage();
        this._teamOAService.showDefaultColumns();

        // eslint-disable-next-line @typescript-eslint/dot-notation
        // if (!this._cdRef['destroyed']) {
        //     this._cdRef.detectChanges();
        // }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    closeOAFilter() {
        // find unapplied metrics
        // eslint-disable-next-line no-extra-boolean-cast
        if (!!this.filterOptions.filterMetrics.length) {
            this.filterOptions.filterMetrics =
                this.filterOptions.filterMetrics.filter((a) => {
                    const d = this.appliedFilters.filter(
                        (b) => b.value === a.value,
                    );
                    if (!d.length) return false;
                    return true;
                });
        }

        // this.oafilteropened = false;
        // this.filterToggled.emit(this.oafilteropened);
        this.closeModal();
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    onOaFilterMetricSelected(evt) {
        this.tempMetricValue = evt;
        this.oafilterMetricsSelected = evt;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    addMetricToFilters() {
        const existingmetric = this.filterOptions.filterMetrics.find(
            (s) => s.metricId === this.oafilterMetricsSelected,
        );
        if (this.oafilterMetricsSelected && !existingmetric) {
            const metric = this._teamOAService.getMetricFromId(
                this.oafilterMetricsSelected,
            );
            this.filterOptions.filterMetrics.push({
                value: metric.value,
                label: metric.label,
                disabled: metric.disabled,
            });
            this.noFilterOptionsSelected = false;
            this._teamOAService.toggleMetricFromGlobalFilter(
                this.oafilterMetricsSelected,
                true,
            );
            this.oafilterMetricsSelected = null;
            this.tempMetricValue = null;
            // this._cdRef.detectChanges();
        }
    }

    toggleShowActivePerformers($event: Event): void {
        const target = $event.target as HTMLInputElement;
        target.checked = this._teamOAService.toggleShowActivePerformers();
        this.toggledDisplay.emit(target.checked);
    }

    toggleColumnByIndex(idx: number): void {
        const colconfig = this._teamOAService.toggleColumn(idx, true);
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        if (colconfig && colconfig.bindToId !== null) {
            this._coachingInsightService.updateSubmenu(colconfig.bindToId);
        }
    }

    toggle(event, icon: Icon): void {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const target = event.target;

        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        if (icon && icon.state !== undefined) {
            icon.state = !icon.state;
            if (icon.class && icon.counter !== icon.class.length - 1) {
                icon.counter++;
            } else icon.counter = 0;
        }

        if (icon.action) {
            this[icon.action].apply(
                this,
                icon.actionParams instanceof Array
                    ? icon.actionParams
                    : [icon.actionParams],
            );
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    removeMetricFromFilters(option: IOption) {
        this.filterOptions.filterMetrics.splice(
            this.filterOptions.filterMetrics.findIndex(
                (s) => s.value === option.value,
            ),
            1,
        );
        this._teamOAService.toggleMetricFromGlobalFilter(option.value, false);
        this.oafilterMetricsSelected = null;
        // this._cdRef.detectChanges();
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnDestroy() {
        this.filterOptions = null;
        // eslint-disable-next-line @typescript-eslint/dot-notation
        // if (!this._cdRef['destroyed']) {
        //     this._cdRef.detach();
        // }
        this.destroyedComponent = false;
        // this.toggleActiveSub.unsubscribe();
        this.ColumnsConfigSub.unsubscribe();
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    trackFilterLabel(index, item: any) {
        return typeof item === 'undefined' ? index : item.label;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    trackFilterOptions(index, item: Metric) {
        return typeof item === 'undefined' ? index : item.label;
    }
}
